webpackJsonp([68],{

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_summary_vue__ = __webpack_require__(2120);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_987587e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_summary_vue__ = __webpack_require__(2979);
function injectStyle (ssrContext) {
  __webpack_require__(2973)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-987587e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_987587e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'title-header',
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		pbZero: {
			type: Boolean,
			default: false
		},
		pollName: String,
		title: String,
		urlImage: String
	}
});

/***/ }),

/***/ 1482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'download-btn',
	props: {
		alt: String,
		disabled: {
			type: Boolean,
			default: false
		},
		height: [Number, String],
		urlImage: String
	}
});

/***/ }),

/***/ 1487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__ = __webpack_require__(1460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__ = __webpack_require__(1490);
function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbead12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("6a611bf6", content, true, {});

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header .text[data-v-bdbead12]{font-family:NeuzeitGroTBold;font-size:18px}.title-header .wrapper[data-v-bdbead12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e7e7e7;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px 10px}.title-header .wrapper.pb-0[data-v-bdbead12]{padding-bottom:0}.subtitle-header[data-v-bdbead12]{font-family:NeuzeitGroT;font-size:18px}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/title-header.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,4BAA+B,AAC/B,cAAgB,CACjB,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAiC,AACjC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACrB,AACD,6CACI,gBAAoB,CACvB,AACD,kCACE,wBAA2B,AAC3B,cAAgB,CACjB","file":"title-header.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header .text[data-v-bdbead12] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 18px;\n}\n.title-header .wrapper[data-v-bdbead12] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #e7e7e7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px 10px;\n}\n.title-header .wrapper.pb-0[data-v-bdbead12] {\n    padding-bottom: 0px;\n}\n.subtitle-header[data-v-bdbead12] {\n  font-family: \"NeuzeitGroT\";\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header"},[_c('div',{staticClass:"wrapper",class:{ 'pb-0': _vm.pbZero }},[_c('div',[(_vm.urlImage)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.urlImage,"alt":_vm.urlImage}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(("color:" + (_vm.gray ? _vm.$appColors.info : _vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+" "),(_vm.pollName)?_c('span',{staticClass:"subtitle-header"},[_vm._v("- "+_vm._s(_vm.pollName))]):_vm._e()])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_btn_vue__ = __webpack_require__(1482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1630ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_btn_vue__ = __webpack_require__(1517);
function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d1630ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1630ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("36543dd7", content, true, {});

/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.download-btn[data-v-5d1630ab]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff!important;border-radius:2px!important;display:-webkit-box;display:-ms-flexbox;display:flex;height:45px!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:5px;width:45px!important}.download-btn-img[data-v-5d1630ab]{height:27px!important}.download-btn[data-v-5d1630ab]:disabled{cursor:not-allowed;opacity:.5}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/download-btn.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAqC,AACrC,4BAA8B,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAwB,AACxB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAiB,AACjB,oBAAuB,CACxB,AACD,mCACI,qBAAwB,CAC3B,AACD,wCACI,mBAAoB,AACpB,UAAa,CAChB","file":"download-btn.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.download-btn[data-v-5d1630ab] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #ffffff !important;\n  border-radius: 2px !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 45px !important;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: 5px;\n  width: 45px !important;\n}\n.download-btn-img[data-v-5d1630ab] {\n    height: 27px !important;\n}\n.download-btn[data-v-5d1630ab]:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"download-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('download-item')}}},[_c('img',{staticClass:"download-btn-img",attrs:{"src":_vm.urlImage,"alt":_vm.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

function data() {
	return {
		showButton: true
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	data: data,
	mounted: function mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed: function destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll: function handleScroll() {
			var scrollHeight = document.documentElement.scrollHeight;
			var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			var clientHeight = document.documentElement.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight) {
				this.showButton = true;
			} else {
				this.showButton = true;
			}
		},
		scrollToTop: function scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	},
	props: {
		buttonText: {
			type: String,
			default: 'Subir'
		}
	}
});

/***/ }),

/***/ 1860:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 1861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(536);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 1862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_float_vue__ = __webpack_require__(1714);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75290700_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_float_vue__ = __webpack_require__(1865);
function injectStyle (ssrContext) {
  __webpack_require__(1863)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75290700"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_btn_float_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75290700_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_btn_float_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1863:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1864);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("fb47c8c6", content, true, {});

/***/ }),

/***/ 1864:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.scroll-to-top[data-v-75290700]{position:fixed;bottom:50px;right:50px}.btnS[data-v-75290700]{background-color:#ffb74c;color:#fff;padding:5px 15px;font-size:18px;font-weight:700;border-radius:20px}.btnS[data-v-75290700],.btnS img[data-v-75290700]{display:-webkit-box;display:-ms-flexbox;display:flex}.btnS img[data-v-75290700]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end}", "", {"version":3,"sources":["/opt/build/repo/src/modules/evaluation-360/components/evaluation/btn-float.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,gCACE,eAAgB,AAChB,YAAa,AACb,UAAY,CACb,AACD,uBACE,yBAA0B,AAC1B,WAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,gBAAkB,AAClB,kBAAoB,CAIrB,AACD,kDAJE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAcf,AAZD,2BAII,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,0BAA2B,AACvB,qBAAsB,AAC1B,qBAAsB,AAClB,kBAAmB,AACf,mBAAqB,CAChC","file":"btn-float.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.scroll-to-top[data-v-75290700] {\n  position: fixed;\n  bottom: 50px;\n  right: 50px;\n}\n.btnS[data-v-75290700] {\n  background-color: #FFB74C;\n  color: #ffffff;\n  padding: 5px 15px;\n  font-size: 18px;\n  font-weight: bold;\n  border-radius: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.btnS img[data-v-75290700] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-line-pack: center;\n        align-content: center;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: end;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('div',{staticClass:"scroll-to-top",on:{"click":_vm.scrollToTop}},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btnS"},[_vm._v("Subir "),_c('img',{attrs:{"src":"/static/img/up.svg","alt":"btn-up"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_diagnosis_title_header__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_download_btn__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_charts_graphic__ = __webpack_require__(2975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_evaluation_360_components_evaluation_btn_float__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda__ = __webpack_require__(17);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var pollIds, params, _ref2, response, mergeArray, maxValueV;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoading = true;
						_context.prev = 1;
						pollIds = this.process.pollId;
						params = {
							pollId: pollIds,
							employeeEvaluatedId: this.selectedEmployee.id
						};
						_context.next = 6;
						return this.$httpPraktiko.post('process/report-detail/' + this.process.id, params);

					case 6:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.competences = response.dispersion;
						this.roles = response.roles;
						this.roles = this.roles.map(function (r) {
							var newR = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r);
							if (r.name === 'Cliente Interno') {
								newR.abbreviation = 'CI';
							} else if (r.name === 'Jefe') {
								newR.abbreviation = 'J';
							} else if (r.name === 'Par') {
								newR.abbreviation = 'P';
							} else if (r.name === 'Colaborador') {
								newR.abbreviation = 'C';
							}
							return newR;
						});
						this.scales = response.scales;
						// this.details = response.details;
						this.kpis = response.competenceSummary;
						this.totalKpi = response.totalWeighing;

						// Validar que graphicData exista y tenga datos
						if (response.graphicData && response.graphicData.length > 0) {
							mergeArray = response.graphicData.reduce(function (result, obj) {
								return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, result, {
									competencies: (result.competencies || []).concat(obj.competencies)
								});
							}, {});

							mergeArray.values = mergeArray.competencies;
							delete mergeArray.competencies;
							this.typeCompetencies = mergeArray.values.filter(function (obj, index, array) {
								return index === array.findIndex(function (item) {
									return item.nameCompetencie === obj.nameCompetencie;
								});
							});
							mergeArray.values = mergeArray.values.map(function (f) {
								var newF = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, f);
								newF.v2 = f.avg;
								newF.v1 = 0;
								return newF;
							});
							maxValueV = mergeArray.values.reduce(function (maxValue, currentValue) {
								return Math.max(maxValue, currentValue.v2);
							}, Number.NEGATIVE_INFINITY);

							mergeArray.maxValue = maxValueV + 1;
							mergeArray.greyZone = {
								max: maxValueV,
								min: 0
							};
							this.dataGraphic = mergeArray;
						} else {
							// Si no hay datos, asignar un objeto vacío con la estructura correcta
							this.dataGraphic = {
								values: [],
								maxValue: 1,
								greyZone: {
									max: 0,
									min: 0
								}
							};
							this.typeCompetencies = [];
							// Sin gráfico no hay canvas que capturar; la exportación seguirá el
							// camino de error existente en downloadReport/sendEmail.
							this.canvasDataUrl = null;
							this.isCanvasReady = false;
						}
						_context.next = 21;
						break;

					case 17:
						_context.prev = 17;
						_context.t0 = _context['catch'](1);

						console.error('[report-summary] loadData:', _context.t0);
						this.showGenericError();

					case 21:
						_context.prev = 21;

						this.isLoading = false;
						return _context.finish(21);

					case 24:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 17, 21, 24]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var downloadReport = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(type, contentType) {
		var pollIds, body, myGraphs, canvas, graphs, code, _ref4, pdfData, blob;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						pollIds = this.process.pollId;
						body = {
							processId: this.process.id,
							pollId: pollIds,
							employeeEvaluatedId: this.selectedEmployee.id
						};

						this.isDownloading = true;
						_context2.prev = 3;
						_context2.next = 6;
						return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
							return requestAnimationFrame(resolve);
						});

					case 6:
						// Usar canvas cacheado si está disponible, sino capturar en el momento
						myGraphs = void 0;

						if (!(this.isCanvasReady && this.canvasDataUrl)) {
							_context2.next = 11;
							break;
						}

						myGraphs = this.canvasDataUrl;
						_context2.next = 17;
						break;

					case 11:
						canvas = document.getElementById('canvas');

						if (!canvas) {
							_context2.next = 16;
							break;
						}

						myGraphs = canvas.toDataURL();
						_context2.next = 17;
						break;

					case 16:
						throw new Error('Canvas no encontrado');

					case 17:
						graphs = [myGraphs];

						body.base64 = graphs;
						code = 'evaluation-360';
						_context2.next = 22;
						return this.$httpPraktiko.post('reports/' + code + '/evaluation/' + type, body, { responseType: 'blob' });

					case 22:
						_ref4 = _context2.sent;
						pdfData = _ref4.data;
						blob = generateBlob(pdfData, contentType);

						showDownloadDialog(blob, 'evaluation-360', type);
						_context2.next = 32;
						break;

					case 28:
						_context2.prev = 28;
						_context2.t0 = _context2['catch'](3);

						console.error('[report-summary] downloadReport:', _context2.t0);
						this.showGenericError(_context2.t0 && _context2.t0.message === 'Canvas no encontrado' ? 'No se encontró el gráfico del reporte para generar el PDF.' : undefined);

					case 32:
						_context2.prev = 32;

						this.isDownloading = false;
						return _context2.finish(32);

					case 35:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[3, 28, 32, 35]]);
	}));

	return function downloadReport(_x, _x2) {
		return _ref3.apply(this, arguments);
	};
}();

var sendEmail = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var pollIds, body, myGraphs, canvas, graphs, code;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						pollIds = this.process.pollId;
						body = {
							processId: this.process.id,
							pollId: pollIds,
							employeeEvaluatedId: this.selectedEmployee.id
						};

						this.isDownloading = true;
						_context3.prev = 3;
						_context3.next = 6;
						return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
							return requestAnimationFrame(resolve);
						});

					case 6:
						// Usar canvas cacheado si está disponible, sino capturar en el momento
						myGraphs = void 0;

						if (!(this.isCanvasReady && this.canvasDataUrl)) {
							_context3.next = 11;
							break;
						}

						myGraphs = this.canvasDataUrl;
						_context3.next = 17;
						break;

					case 11:
						canvas = document.getElementById('canvas');

						if (!canvas) {
							_context3.next = 16;
							break;
						}

						myGraphs = canvas.toDataURL();
						_context3.next = 17;
						break;

					case 16:
						throw new Error('Canvas no encontrado');

					case 17:
						graphs = [myGraphs];

						body.base64 = graphs;
						code = 'evaluation-360-pdf';
						_context3.next = 22;
						return this.$httpPraktiko.post('notifications/report-process/' + code, body);

					case 22:
						this.showNotification('Correo enviado Correctamente');
						_context3.next = 29;
						break;

					case 25:
						_context3.prev = 25;
						_context3.t0 = _context3['catch'](3);

						console.error('[report-summary] sendEmail:', _context3.t0);
						this.showGenericError(_context3.t0 && _context3.t0.message === 'Canvas no encontrado' ? 'No se encontró el gráfico del reporte para enviar por correo.' : undefined);

					case 29:
						_context3.prev = 29;

						this.isDownloading = false;
						return _context3.finish(29);

					case 32:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[3, 25, 29, 32]]);
	}));

	return function sendEmail() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var generateBlob = __WEBPACK_IMPORTED_MODULE_8__shared_helper__["a" /* default */].generateBlob,
    showDownloadDialog = __WEBPACK_IMPORTED_MODULE_8__shared_helper__["a" /* default */].showDownloadDialog,
    getLocalData = __WEBPACK_IMPORTED_MODULE_8__shared_helper__["a" /* default */].getLocalData;


function created() {
	this.loadData();
	this.startDate = __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(this.process.startDate, 'DD/MM/YYYY');
	this.endDate = __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(this.process.endDate, 'DD/MM/YYYY');
}
function mounted() {
	// this.loadData();
}

function goToBack() {
	this.goTo('report-evaluation', { params: { id: this.process.id } });
}

function data() {
	return {
		startDate: null,
		endDate: null,
		competences: [],
		roles: [],
		scales: [],
		dataGraphic: {},
		typeCompetencies: [],
		kpis: [],
		totalKpi: 0,
		showSecondTable: true, // Control visibility of the second table
		secondScales: [], // Data for the second table
		isLoading: true, // Estado de carga inicial
		isDownloading: false, // Estado para descargas
		canvasDataUrl: null, // Cache del canvas capturado tras el evento 'drawn'
		isCanvasReady: false // Indica si el gráfico ya fue dibujado y capturado
	};
}

// Captura el canvas cuando el componente graphic emite 'drawn': en ese
// momento el gráfico ya terminó de dibujarse, así que no hacen falta esperas
// fijas que dejaban carreras (PDF descargado con el gráfico en blanco).
function captureCanvas() {
	var _this = this;

	this.$nextTick(function () {
		try {
			var graphicEl = _this.$refs.graphicComponent && _this.$refs.graphicComponent.$el;
			var canvas = graphicEl && graphicEl.querySelector('canvas');
			if (canvas) {
				_this.canvasDataUrl = canvas.toDataURL();
				_this.isCanvasReady = true;
			}
		} catch (error) {
			// Silencioso: si falla, la exportación avisará al usuario.
			console.warn('No se pudo capturar el canvas automáticamente:', error);
		}
	});
}

function onGraphicDrawError(error) {
	console.error('[report-summary] graphic draw:', error);
	this.showGenericError('No se pudo generar el gráfico del reporte.');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'report-summary',
	data: data,
	created: created,
	mounted: mounted,
	components: {
		titleHeader: __WEBPACK_IMPORTED_MODULE_4__components_diagnosis_title_header__["a" /* default */],
		downloadBtn: __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_download_btn__["a" /* default */],
		graphic: __WEBPACK_IMPORTED_MODULE_6__components_shared_charts_graphic__["a" /* default */],
		btnFloat: __WEBPACK_IMPORTED_MODULE_7__modules_evaluation_360_components_evaluation_btn_float__["a" /* default */]
	},
	methods: {
		loadData: loadData,
		goToBack: goToBack,
		downloadReport: downloadReport,
		sendEmail: sendEmail,
		captureCanvas: captureCanvas,
		onGraphicDrawError: onGraphicDrawError
	},
	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])('evaluation360', {
		process: function process(state) {
			return Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["P" /* pathOr */])(getLocalData('process'), ['process'], state.evaluation360) || [];
		},
		selectedEmployee: function selectedEmployee(state) {
			return Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["P" /* pathOr */])(getLocalData('selectedEmployee'), ['selectedEmployee'], state.evaluation360) || [];
		}
	}), {
		hasChartData: function hasChartData() {
			var values = this.dataGraphic && this.dataGraphic.values;
			return Boolean(values && values.length > 0);
		},

		// El PDF incrusta una captura del canvas, por lo que la exportación se
		// bloquea hasta que el gráfico esté dibujado y capturado. Si el proceso
		// no tiene gráfico (o su sección está oculta), la exportación sigue el
		// camino de error existente en vez de quedar bloqueada para siempre.
		canExportReport: function canExportReport() {
			var chartShouldRender = this.hasChartData && this.scales.length > 0;
			return !this.isLoading && (!chartShouldRender || this.isCanvasReady);
		},
		flattenedTableData: function flattenedTableData() {
			// Early return si no hay datos
			if (!this.competences || this.competences.length === 0) {
				return [];
			}
			var result = [];
			this.competences.forEach(function (competence) {
				competence.questions.forEach(function (question, indexQ) {
					result.push({
						competenceName: competence.competenceName,
						questionName: question.qustionName,
						scaleQuestions: question.scalesQuestion || question.scalesQuestion || [],
						isFirstQuestion: indexQ === 0,
						rowspan: competence.questions.length
					});
				});
			});
			return result;
		},
		detailedTableFiltered: function detailedTableFiltered() {
			// Early return si no hay datos
			if (!this.competences || this.competences.length === 0) {
				return [];
			}

			var result = [];

			// Procesar cada competencia
			this.competences.forEach(function (competence) {
				// Filtrar preguntas que tienen escala con id 3 o 4
				var filteredQuestions = competence.questions.filter(function (question) {
					var hasLowScaleId = question.scalesQuestion.some(function (sq) {
						return sq.point && (sq.id === 3 || sq.id === 4) && competence.indicator;
					});
					return hasLowScaleId;
				});

				// Solo procesar si hay preguntas filtradas
				if (filteredQuestions.length > 0) {
					// Usar los indicadores que vienen del backend
					var sharedIndicator = competence.indicator || {};

					// Crear una fila por cada pregunta, pero con indicadores compartidos
					filteredQuestions.forEach(function (question, index) {
						result.push({
							competenceName: competence.competenceName,
							questionName: question.qustionName,
							indicator: sharedIndicator,
							isFirstQuestion: index === 0,
							rowspan: filteredQuestions.length
						});
					});
				}
			});

			return result;
		}
	})
});

/***/ }),

/***/ 2121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


//
//
//
//
//

/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-undef */
/* eslint-disable indent */
/* eslint-disable comma-spacing */
/* eslint-disable no-underscore */
/* eslint-disable no-plusplus */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-underscore-dangle */
/* eslint-disable space-infix-ops */
/* eslint-disable semi */
/* eslint-disable eqeqeq */
/* eslint-disable no-new */
/* eslint-disable prefer-const */
/* eslint-disable no-mixed-spaces-and-tabs */
var properties = {
	textSize: 12,
	color1: '#246ef5',
	color2: '#8FE84D',
	grayZoneColor: '#F1B15A',
	brechaColor: '#C33825'
};

var RadarChart = function () {
	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RadarChart, [{
		key: 'TOTAL_AREAS',
		get: function get() {
			return this.data.maxValue;
		}
	}, {
		key: 'TEXT_SIZE',
		get: function get() {
			return this.properties.textSize || 10;
		}
	}, {
		key: 'LINE_COLOR_1',
		get: function get() {
			return this.properties.color1 || '#0000aa';
		}
	}, {
		key: 'LINE_COLOR_2',
		get: function get() {
			return this.properties.color2 || '#00aa00';
		}
	}, {
		key: 'GRAY_ZONE_COLOR',
		get: function get() {
			return this.properties.grayZoneColor || '#aaed99';
		}
	}, {
		key: 'BRECHA_COLOR',
		get: function get() {
			return this.properties.brechaColor || '#881111';
		}

		/**
   * Creacion de objeto Grafico
   @param {canvas} canvas
   @param {object} data
   @param {object} properties
   */

	}], [{
		key: 'LINES_PER_AREAS',
		get: function get() {
			return 5;
		}
	}, {
		key: 'STROKE_WIDTH',
		get: function get() {
			return 0.3;
		}
	}, {
		key: 'LINES_BACKGROUND_COLOR',
		get: function get() {
			return '#333333';
		}
	}, {
		key: 'TEXT_COLOR',
		get: function get() {
			return '#444444';
		}
	}, {
		key: 'PADDING',
		get: function get() {
			return 40;
		}
	}, {
		key: 'DOT_SIZE',
		get: function get() {
			return 5;
		}
	}]);

	function RadarChart(canvas, data) {
		var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RadarChart);

		this.canvas = canvas;
		this.context = canvas.getContext('2d');
		this.data = data;
		this._canvasWidth = this.canvas.width;
		this._canvasHeight = this.canvas.height;
		this.properties = properties;
		this.initCanvas();
		this.draw();
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RadarChart, [{
		key: 'initCanvas',
		value: function initCanvas() {
			// Get the device pixel ratio, falling back to 1.
			var dpr = window.devicePixelRatio || 1;
			// Get the size of the canvas in CSS pixels.
			var rect = this.canvas.getBoundingClientRect();
			// Give the canvas pixel dimensions of their CSS
			// size * the device pixel ratio.
			this.canvas.width = rect.width * dpr;
			this.canvas.height = rect.height * dpr;

			this.canvas.style.width = this.canvasWidth;
			this.canvas.style.height = this.canvasHeight;
			// Scale all drawing operations by the dpr, so you
			// don't have to worry about the difference.
			this.context.scale(dpr, dpr);
			// Center in 0,0
			this.context.translate(this.canvasWidth / 2, this.canvasHeight / 2);
		}
	}, {
		key: 'drawBackgroundLines',
		value: function drawBackgroundLines() {
			var space = this.maxRadius / (this.TOTAL_AREAS * RadarChart.LINES_PER_AREAS);
			var radius = space;
			this.context.lineWidth = RadarChart.STROKE_WIDTH;
			this.context.strokeStyle = RadarChart.LINES_BACKGROUND_COLOR;
			for (var i = 0; i < this.TOTAL_AREAS * RadarChart.LINES_PER_AREAS; i++) {
				if ((i + 1) % RadarChart.LINES_PER_AREAS == 0) {
					this.context.globalAlpha = 1;
				} else {
					this.context.globalAlpha = 0.4;
				}
				this.context.beginPath();

				for (var j = 0; j < this.itemCount; j++) {
					var rad = j * 2 * Math.PI / this.itemCount;
					var x = Math.cos(rad) * radius;
					var y = Math.sin(rad) * radius;
					if (j == 0) {
						this.context.moveTo(x, y);
					} else {
						this.context.lineTo(x, y);
					}
				}
				this.context.closePath();
				this.context.stroke();
				radius += space;
			}
		}
	}, {
		key: 'drawGrayZone',
		value: function drawGrayZone() {
			if (!this.data.greyZone) {
				return;
			}
			var max = this.data.greyZone.max / this.data.maxValue * this.maxRadius;
			var min = this.data.greyZone.min / this.data.maxValue * this.maxRadius;

			this.context.globalAlpha = 0.25;
			this.context.fillStyle = this.GRAY_ZONE_COLOR;
			this.context.beginPath();
			this.context.arc(0, 0, max, 0, Math.PI * 2, false); // outer (filled)
			this.context.arc(0, 0, min, 0, Math.PI * 2, true); // outer (unfills it)
			this.context.fill();
			this.context.globalAlpha = 1;
		}
	}, {
		key: 'drawPoints',
		value: function drawPoints() {
			var _this2 = this;

			var _this = this;
			this.context.font = 'bold ' + this.TEXT_SIZE + 'px Arial';
			function drawDots(x, y, value, rad, outer, color) {
				_this.context.save();
				// Draw Dot
				_this.context.fillStyle = color;
				_this.context.beginPath();
				_this.context.translate(x, y);
				_this.context.arc(0, 0, RadarChart.DOT_SIZE, 0, Math.PI * 2, true); // outer (filled)
				_this.context.fill();

				var distance = Math.sqrt(y * y + x * x);
				var u1 = x / distance;
				var v1 = y / distance;
				// Draw Text Dot
				if (outer) {
					_this.context.translate(u1 * 12, v1 * 12);
				} else {
					_this.context.translate(u1 * -14, v1 * -14);
				}
				_this.context.rotate(-_this.rotation);
				var xRot = Math.cos(rad + _this.rotation) * _this.maxRadius;
				if (outer) {
					if (xRot > 30) {
						_this.context.textAlign = 'left';
					} else if (xRot < -30) {
						_this.context.textAlign = 'right';
					} else {
						_this.context.textAlign = 'center';
					}
				} else if (xRot > 220) {
					_this.context.textAlign = 'right';
				} else if (xRot < -220) {
					_this.context.textAlign = 'left';
				} else {
					_this.context.textAlign = 'center';
				}
				_this.context.textBaseline = 'middle';
				_this.context.fillStyle = RadarChart.TEXT_COLOR;
				_this.context.fillText('' + value.toFixed(2), 0, 0);

				_this.context.restore();
			}
			this.data.values.forEach(function (value, index) {
				var v1 = value.v1;
				var v2 = value.v2;
				var rad = index * 2 * Math.PI / _this2.itemCount;
				var max1 = v1 / _this2.data.maxValue * _this2.maxRadius;
				var max2 = v2 / _this2.data.maxValue * _this2.maxRadius;
				var x1 = Math.cos(rad) * max1;
				var y1 = Math.sin(rad) * max1;
				var x2 = Math.cos(rad) * max2;
				var y2 = Math.sin(rad) * max2;
				// drawDots(x1, y1, v1, rad, max1 > max2, this.LINE_COLOR_1); draw line blue
				drawDots(x2, y2, v2, rad, max2 > max1, _this2.LINE_COLOR_2);
			});
		}
	}, {
		key: 'drawDataLine',
		value: function drawDataLine() {
			var _this = this;
			function drawLines(values, color) {
				_this.context.beginPath();
				values.forEach(function (value, index) {
					var rad = index * 2 * Math.PI / _this.itemCount;
					var distance = value / _this.data.maxValue * _this.maxRadius;
					_this.context.strokeStyle = color;
					_this.context.lineWidth = RadarChart.STROKE_WIDTH * 10;
					var x = Math.cos(rad) * distance;
					var y = Math.sin(rad) * distance;
					if (index === 0) {
						_this.context.moveTo(x, y);
					} else {
						_this.context.lineTo(x, y);
					}
				});
				_this.context.closePath();
				_this.context.stroke();
			}
			var values2 = this.data.values.map(function (e) {
				return e.v2;
			});
			var values1 = this.data.values.map(function (e) {
				return e.v1;
			});
			drawLines(values1, this.LINE_COLOR_1);
			drawLines(values2, this.LINE_COLOR_2);
		}
	}, {
		key: 'drawText',
		value: function drawText() {
			var _this3 = this;

			this.context.fillStyle = RadarChart.TEXT_COLOR;
			var maxRadius = this.maxRadius;
			var itemCount = this.itemCount;
			var rotation = this.rotation;
			var step = maxRadius / this.TOTAL_AREAS;
			this.context.font = this.TEXT_SIZE + 'px Arial';
			// DRAW LOCATION NUMBER TEXT
			for (var i = 0; i < this.TOTAL_AREAS + 1; i++) {
				var rad = (this.itemCount - 1) * 2 * Math.PI / itemCount;
				var x = Math.cos(rad) * step * i;
				var y = Math.sin(rad) * step * i;
				this.context.save();
				this.context.translate(x - 15, y - 10);
				this.context.rotate(-rotation);
				this.context.fillText(i, 0, 0);
				this.context.restore();
			}
			// DRAW NAME DATA ITEMS
			this.context.font = 'bold ' + this.TEXT_SIZE + 'px Arial';
			this.data.values.forEach(function (e, index) {
				_this3.context.save();
				var name = e.name;
				var rad = index * 2 * Math.PI / itemCount;
				var x = Math.cos(rad) * (maxRadius + RadarChart.PADDING);
				var y = Math.sin(rad) * (maxRadius + RadarChart.PADDING);
				_this3.context.translate(x, y);
				_this3.context.rotate(-rotation);
				var xRot = Math.cos(rad + rotation) * maxRadius;
				if (xRot > 30) {
					_this3.context.textAlign = 'left';
				} else if (xRot < -30) {
					_this3.context.textAlign = 'right';
				} else {
					_this3.context.textAlign = 'center';
				}
				_this3.context.fillStyle = e.color;
				// this.context.fillText(name, 0, 0);
				// this.context.restore();
				var maxLength = 25;
				var lines = [];
				if (name.length > maxLength) {
					var currentLine = '';
					var words = name.split(' ');
					words.forEach(function (word, i) {
						if (currentLine.length + word.length <= maxLength) {
							currentLine += word + ' ';
						} else {
							lines.push(currentLine.trim());
							currentLine = word + ' ';
						}
						if (i === words.length - 1) {
							lines.push(currentLine.trim());
						}
					});
				} else {
					lines.push(name);
				}

				lines.forEach(function (line, j) {
					_this3.context.fillText(line, 0, j * 20);
				});

				_this3.context.restore();
			});
		}
	}, {
		key: 'drawBrecha',
		value: function drawBrecha() {
			var _this = this;
			this.context.strokeStyle = this.BRECHA_COLOR;
			this.context.fillStyle = this.BRECHA_COLOR;
			this.context.lineWidth = RadarChart.STROKE_WIDTH * 5;
			function drawArrow(x1, y1, x2, y2) {
				_this.context.save();
				_this.context.translate(x1, y1);
				_this.context.rotate(Math.atan2(y1 - y2, x1 - x2) + Math.PI / 2);
				_this.context.beginPath();
				_this.context.moveTo(0, 0);
				_this.context.lineTo(-5, 8);
				_this.context.lineTo(5, 8);
				_this.context.fill();
				_this.context.restore();
			}
			this.data.values.forEach(function (value, index) {
				var brecha = value.brecha || _this.data.brecha;
				if (Math.abs(value.v1 - value.v2) > brecha) {
					// Dibujar brecha
					var rad = index * 2 * Math.PI / _this.itemCount;
					var max1 = value.v1 / _this.data.maxValue * _this.maxRadius;
					var max2 = value.v2 / _this.data.maxValue * _this.maxRadius;
					var x1 = Math.cos(rad) * (max1 + (max1 < max2 ? 10 : -10));
					var y1 = Math.sin(rad) * (max1 + (max1 < max2 ? 10 : -10));
					var x2 = Math.cos(rad) * (max2 + (max1 > max2 ? 10 : -10));
					var y2 = Math.sin(rad) * (max2 + (max1 > max2 ? 10 : -10));
					_this.context.beginPath();
					_this.context.moveTo(x1, y1);
					_this.context.lineTo(x2, y2);
					_this.context.stroke();
					// Draw Arrow end
					drawArrow(x1, y1, x2, y2);
					drawArrow(x2, y2, x1, y1);
				}
			});
		}
	}, {
		key: 'draw',
		value: function draw() {
			this.context.save();
			this.context.rotate(this.rotation);
			// Dibujar las lineas de fondo
			this.drawBackgroundLines();
			// Dibujar la zona "gris"
			this.drawGrayZone();
			// Dibujar las lineas de datos
			this.drawDataLine();
			this.drawPoints();
			this.drawBrecha();
			// Draw Text
			this.drawText();
			this.context.restore();
		}
	}, {
		key: 'itemCount',
		get: function get() {
			return this.data.values ? this.data.values.length : 0;
		}
	}, {
		key: 'canvasWidth',
		get: function get() {
			return this._canvasWidth;
		}
	}, {
		key: 'canvasHeight',
		get: function get() {
			return this._canvasHeight;
		}
	}, {
		key: 'maxRadius',
		get: function get() {
			var maxSize = Math.min(this.canvasWidth, this.canvasHeight) / 2;
			return maxSize - RadarChart.PADDING * 2;
		}
	}, {
		key: 'rotation',
		get: function get() {
			if (this.itemCount % 2) {
				return -1.5 * Math.PI / this.itemCount;
			}
			return Math.PI / this.itemCount;
		}
	}]);

	return RadarChart;
}();

/**
 * Instanciacion de grafico
 */

function drawChart(data) {
	var _this4 = this;

	// Historical delay: keeps fonts/layout ready before drawing on the canvas.
	setTimeout(function () {
		try {
			var canvas = _this4.$el.querySelector('canvas');
			new RadarChart(canvas, data, properties);
			// Notify parents exactly when the canvas has content, so they can
			// capture it instead of relying on fixed-time waits.
			_this4.$emit('drawn');
		} catch (error) {
			console.error('[graphic] RadarChart:', error);
			_this4.showGenericError('ERROR EN GRÁFICO');
			_this4.$emit('drawn-error', error);
		}
	}, 2000);
}

function mounted() {
	this.drawChart(this.data);
}

function data() {
	return {
		// properties: {
		// 	textSize: 10,
		// 	color1: '#0000aa',
		// 	color2: '#00aa00',
		// 	grayZoneColor: '#aa2299',
		// 	brechaColor: '#881111',
		// },
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'graphic',
	data: data,
	mounted: mounted,
	props: {
		data: {
			type: Object,
			default: function _default() {}
		}
	},
	methods: {
		drawChart: drawChart
	},
	watch: {
		data: {
			handler: function handler(newVal) {
				this.drawChart(newVal);
			}
		}
	}
});

/***/ }),

/***/ 2973:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("2209c5d0", content, true, {});

/***/ }),

/***/ 2974:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header[data-v-987587e4]{color:#f09c2b;font-size:16px;font-weight:700;text-shadow:0 1px 2px rgba(0,0,0,.1)}.date-header[data-v-987587e4]{color:#545a54;font-size:16px;font-weight:700;text-shadow:0 1px 1px rgba(0,0,0,.05)}.methodology[data-v-987587e4]{width:90%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:20px auto;border:1px solid #e7e7e7;background:linear-gradient(135deg,#e7e7e7,hsla(0,0%,91%,.8));border-radius:20px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.08);box-shadow:0 4px 12px rgba(0,0,0,.08)}.methodology .meth[data-v-987587e4]{color:#5ed52b!important;font-size:18px;font-weight:700;padding:15px;text-shadow:0 1px 2px rgba(0,0,0,.1)}.methodology .parraf[data-v-987587e4]{color:#858585!important;font-size:14px;padding:15px;line-height:1.5}.columns-competencies[data-v-987587e4]{width:90%;display:grid;gap:15px;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:20px auto 50px;grid-template-columns:1fr 1fr 1fr}.columns-competencies .title-box[data-v-987587e4]{color:#5ed52b;margin:0!important;padding:0!important;font-weight:600;text-shadow:0 1px 1px rgba(0,0,0,.1)}.columns-competencies .line[data-v-987587e4]{width:40%;margin-bottom:10px;border:1px solid #5ed52b;background:-webkit-gradient(linear,left top,right top,from(transparent),color-stop(#5ed52b),to(transparent));background:linear-gradient(90deg,transparent,#5ed52b,transparent);height:2px}.columns-competencies .box[data-v-987587e4]{width:100%;height:100%;background:linear-gradient(145deg,#fff,hsla(0,0%,100%,.95));border:1px solid #e7e7e7;border-radius:12px;padding:15px 25px 20px;color:#858585!important;-webkit-box-shadow:0 4px 8px rgba(0,0,0,.06);box-shadow:0 4px 8px rgba(0,0,0,.06)}.columns-competencies .box .table-evaluation[data-v-987587e4]{width:100%;border:1px solid #e7e7e7;border-collapse:collapse;text-align:center;margin-top:10px}.columns-competencies .box .table-evaluation td[data-v-987587e4],.columns-competencies .box .table-evaluation th[data-v-987587e4]{border:1px solid #e7e7e7;padding:8px 5px}.columns-competencies .box .table-evaluation th[data-v-987587e4]{color:#f09c2b;background-color:#e7e7e7;font-weight:700}.columns-competencies .box ol[data-v-987587e4],.columns-competencies .box ul[data-v-987587e4]{padding-left:20px;margin:10px 0 0}.columns-competencies .box ol li[data-v-987587e4],.columns-competencies .box ul li[data-v-987587e4]{margin-bottom:8px;line-height:1.4}.global-results-columns[data-v-987587e4]{grid-template-columns:1fr 1fr;justify-items:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.global-results-columns div[data-v-987587e4]{-ms-flex-direction:column;flex-direction:column;width:100%}.global-results-columns .box[data-v-987587e4],.global-results-columns div[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal}.global-results-columns .box[data-v-987587e4]{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}.results-tables-container[data-v-987587e4]{width:90%;display:grid;gap:15px;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;grid-template-columns:1fr;max-width:800px}.results-tables-container .title-box[data-v-987587e4]{color:#5ed52b;margin:0!important;padding:0!important}.results-tables-container .line[data-v-987587e4]{width:40%;margin-bottom:10px;border:1px solid #5ed52b}.results-tables-container .box[data-v-987587e4]{width:100%;height:auto;min-height:200px;background-color:#fff;border:1px solid #e7e7e7;border-radius:10px;padding:20px 25px;color:#858585!important}.results-tables-container.has-kpis[data-v-987587e4]{grid-template-columns:1fr;max-width:100%;justify-items:center}.results-tables-container.has-kpis>div[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;max-width:800px}.results-tables-container.has-kpis .box[data-v-987587e4]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.detailed-table-section[data-v-987587e4],.diagram-dispersion[data-v-987587e4],.global-results[data-v-987587e4]{width:90%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:20px auto}.detailed-table-section .results[data-v-987587e4],.diagram-dispersion .results[data-v-987587e4],.global-results .results[data-v-987587e4]{color:#f09c2b;font-size:18px;font-weight:700;text-shadow:0 2px 4px rgba(0,0,0,.1);margin-bottom:15px}.detailed-table-section .connt-info[data-v-987587e4],.diagram-dispersion .connt-info[data-v-987587e4],.global-results .connt-info[data-v-987587e4]{width:80%;border:1px solid #e7e7e7;background:linear-gradient(145deg,#fff,hsla(0,0%,100%,.95));display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;margin:20px auto;padding:20px 25px;color:#858585!important;border-radius:20px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.08);box-shadow:0 4px 12px rgba(0,0,0,.08);line-height:1.5}.table-evaluation[data-v-987587e4]{width:100%;border:1px solid #e7e7e7;border-collapse:collapse;text-align:center;min-height:180px;border-radius:10px;overflow:hidden;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.08);box-shadow:0 4px 12px rgba(0,0,0,.08)}.table-evaluation tr td[data-v-987587e4],.table-evaluation tr th[data-v-987587e4]{border:1px solid #e7e7e7;padding:10px 8px}.table-evaluation tr th[data-v-987587e4]{color:#f09c2b;background:linear-gradient(135deg,#e7e7e7,hsla(0,0%,91%,.8));font-weight:700;text-shadow:0 1px 1px rgba(0,0,0,.1)}.table-evaluation tr tr[data-v-987587e4]:nth-child(2n){background-color:rgba(0,0,0,.02)}.tables-container[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:20px;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tables-container.has-kpis[data-v-987587e4]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.tables-container.has-kpis .table-section[data-v-987587e4]{-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:48%}.tables-container[data-v-987587e4]:not(.has-kpis){-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tables-container:not(.has-kpis) .table-section[data-v-987587e4]{-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:100%}.table-subtitle[data-v-987587e4]{color:#5ed52b;font-size:14px;font-weight:700;margin:0 0 10px;text-align:center}.character[data-v-987587e4]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;padding:10px 0}.character-abbreviation[data-v-987587e4]{border-radius:50px;border:none;width:22px;height:22px;color:#fff;font-weight:700;text-align:center;background:linear-gradient(135deg,#5ed52b,rgba(94,213,43,.8));-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);box-shadow:0 2px 4px rgba(0,0,0,.2);cursor:pointer}.point-value[data-v-987587e4]{color:#5ed52b;font-size:10px;padding:0;margin:0;font-weight:700}.scale-entry[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px}.scale-badge[data-v-987587e4],.scale-entry[data-v-987587e4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.scale-badge[data-v-987587e4]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#f09c2b,#ffb74c);color:#fff;font-weight:700;font-size:12px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);box-shadow:0 2px 4px rgba(0,0,0,.2);border:2px solid #fff}.scale-label[data-v-987587e4]{color:#858585;font-size:12px;font-weight:500}.score-display[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:5px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.score-badge[data-v-987587e4]{background-color:#5ed52b;color:#fff;padding:3px 8px;border-radius:12px;font-weight:700;font-size:10px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.2);box-shadow:0 1px 3px rgba(0,0,0,.2)}.percentage-badge[data-v-987587e4]{display:inline-block;padding:4px 8px;border-radius:16px;background:linear-gradient(135deg,#5ed52b,#55ac4b);color:#fff;font-weight:700;font-size:10px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);box-shadow:0 2px 4px rgba(0,0,0,.2);border:1px solid #fff}.percentage-badge.total-badge[data-v-987587e4]{background:linear-gradient(135deg,#f09c2b,#ffb74c);font-size:12px;padding:6px 12px}.character-dispersion[data-v-987587e4]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:12px 35px;color:#858585!important;background:linear-gradient(135deg,#e7e7e7,hsla(0,0%,91%,.9))!important;border-radius:8px;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.08);box-shadow:0 2px 6px rgba(0,0,0,.08)}.t-dispersion-title[data-v-987587e4]{width:100%;border:1px solid #e7e7e7;border-collapse:collapse;text-align:center;margin:0;table-layout:fixed;border-radius:10px;overflow:hidden;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.08);box-shadow:0 4px 12px rgba(0,0,0,.08)}.t-dispersion-title tr td[data-v-987587e4],.t-dispersion-title tr th[data-v-987587e4]{border:1px solid #e7e7e7;padding:8px 5px;color:#858585;background:linear-gradient(135deg,#e7e7e7,hsla(0,0%,91%,.8));font-weight:600;text-shadow:0 1px 1px rgba(0,0,0,.1)}.t-dispersion[data-v-987587e4]{width:100%;border:1px solid #e7e7e7;border-collapse:collapse;text-align:center;margin:0;table-layout:fixed;border-radius:10px;overflow:hidden;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.08);box-shadow:0 4px 12px rgba(0,0,0,.08);-webkit-transition:-webkit-box-shadow .3s ease;transition:-webkit-box-shadow .3s ease;transition:box-shadow .3s ease;transition:box-shadow .3s ease,-webkit-box-shadow .3s ease}.t-dispersion[data-v-987587e4]:hover{-webkit-box-shadow:0 6px 16px rgba(0,0,0,.12);box-shadow:0 6px 16px rgba(0,0,0,.12)}.t-dispersion tr td[data-v-987587e4],.t-dispersion tr th[data-v-987587e4]{border:1px solid #e7e7e7;padding:8px 5px;color:#858585;vertical-align:middle;-webkit-transition:background-color .2s ease;transition:background-color .2s ease}.t-dispersion tr th[data-v-987587e4]{background:linear-gradient(135deg,rgba(94,213,43,.1),rgba(94,213,43,.05));font-weight:600}.t-dispersion tr:hover td[data-v-987587e4]{background-color:rgba(94,213,43,.05)}.nested-table[data-v-987587e4]{width:100%;border:none;border-collapse:collapse;margin:0;padding:0;table-layout:fixed}.nested-table tr td[data-v-987587e4]{border:none;padding:4px 0;color:#858585;font-size:12px;line-height:1.4;text-align:start;word-wrap:break-word;overflow-wrap:break-word;-webkit-hyphens:auto;hyphens:auto;max-width:100%}.grafic-content[data-v-987587e4]{padding:30px;border:1px solid #e7e7e7;border-radius:12px;-webkit-box-shadow:0 4px 16px rgba(0,0,0,.08);box-shadow:0 4px 16px rgba(0,0,0,.08);background:#fff;position:relative;overflow:hidden}.grafic-content[data-v-987587e4]:after{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:radial-gradient(circle at top right,rgba(94,213,43,.03),transparent 70%);pointer-events:none}.leyend-graphic[data-v-987587e4]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:85%;max-width:800px;margin:25px auto 0;gap:20px;padding:25px;background:linear-gradient(145deg,#fff,hsla(0,0%,100%,.98));border:1px solid hsla(0,0%,91%,.8);border-radius:16px;-webkit-box-shadow:0 4px 20px rgba(0,0,0,.06);box-shadow:0 4px 20px rgba(0,0,0,.06)}.leyend-graphic .legend-item[data-v-987587e4],.leyend-graphic[data-v-987587e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}.leyend-graphic .legend-item[data-v-987587e4]{gap:12px;padding:12px 20px;border-radius:50px;background:linear-gradient(145deg,hsla(0,0%,100%,.9),#fff);border:1px solid rgba(0,0,0,.04);-webkit-box-shadow:0 4px 10px rgba(0,0,0,.04);box-shadow:0 4px 10px rgba(0,0,0,.04);z-index:1}.leyend-graphic .legend-item .legend-color[data-v-987587e4]{width:18px;height:18px;border-radius:50%;-webkit-box-shadow:0 3px 6px rgba(0,0,0,.15);box-shadow:0 3px 6px rgba(0,0,0,.15);border:2px solid #fff;position:relative}.leyend-graphic .legend-item .legend-color[data-v-987587e4]:after{content:\"\";position:absolute;top:-2px;left:-2px;right:-2px;bottom:-2px;border-radius:50%;background:inherit;opacity:.2;z-index:-1}.leyend-graphic .legend-item p[data-v-987587e4]{margin:0;font-size:13px;font-weight:500;color:#858585;letter-spacing:.2px}.report-summary-wrapper[data-v-987587e4]{position:relative;min-height:100vh}.loading-overlay[data-v-987587e4]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:hsla(0,0%,100%,.85);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:9999;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}", "", {"version":3,"sources":["/opt/build/repo/src/modules/evaluation-360/components/evaluation/report-summary.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,oCAA0C,CAC3C,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,qCAA2C,CAC5C,AACD,8BACE,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,yBAA0B,AAC1B,6DAAuE,AACvE,mBAAoB,AACpB,8CAAmD,AAC3C,qCAA2C,CACpD,AACD,oCACI,wBAA0B,AAC1B,eAAgB,AAChB,gBAAkB,AAClB,aAAc,AACd,oCAA0C,CAC7C,AACD,sCACI,wBAA0B,AAC1B,eAAgB,AAChB,aAAc,AACd,eAAiB,CACpB,AACD,uCACE,UAAW,AACX,aAAc,AACd,SAAU,AACV,0BAA2B,AACvB,uBAAwB,AACpB,oBAAqB,AAC7B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,sBAAuB,AACvB,iCAAmC,CACpC,AACD,kDACI,cAAe,AACf,mBAAqB,AACrB,oBAAsB,AACtB,gBAAiB,AACjB,oCAA0C,CAC7C,AACD,6CACI,UAAW,AACX,mBAAoB,AACpB,yBAA0B,AAC1B,6GAAmH,AACnH,kEAAsE,AACtE,UAAY,CACf,AACD,4CACI,WAAY,AACZ,YAAa,AACb,4DAAwE,AACxE,yBAA0B,AAC1B,mBAAoB,AACpB,uBAAwB,AACxB,wBAA0B,AAC1B,6CAAkD,AAC1C,oCAA0C,CACrD,AACD,8DACM,WAAY,AACZ,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,eAAiB,CACtB,AACD,kIACQ,yBAA0B,AAC1B,eAAiB,CACxB,AACD,iEACQ,cAAe,AACf,yBAA0B,AAC1B,eAAkB,CACzB,AACD,8FACM,kBAAmB,AACnB,eAAmB,CACxB,AACD,oGACQ,kBAAmB,AACnB,eAAiB,CACxB,AACD,yCACE,8BAA+B,AAC/B,qBAAsB,AACtB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,6CAMQ,0BAA2B,AACvB,sBAAuB,AAC/B,UAAY,CACf,AACD,2FATI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,4BAA8B,CAgBjC,AAXD,8CACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAMZ,0BAA2B,AACvB,qBAAuB,CAClC,AACD,2CACE,UAAW,AACX,aAAc,AACd,SAAU,AACV,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,YAAa,AACb,0BAA2B,AAC3B,eAAiB,CAClB,AACD,sDACI,cAAe,AACf,mBAAqB,AACrB,mBAAsB,CACzB,AACD,iDACI,UAAW,AACX,mBAAoB,AACpB,wBAA0B,CAC7B,AACD,gDACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,sBAA0B,AAC1B,yBAA0B,AAC1B,mBAAoB,AACpB,kBAAmB,AACnB,uBAA0B,CAC7B,AACD,oDACE,0BAA2B,AAC3B,eAAgB,AAChB,oBAAsB,CACvB,AACD,wDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,eAAiB,CACpB,AACD,yDACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,+GACE,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,CACnB,AACD,0IACI,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,qCAA0C,AAC1C,kBAAoB,CACvB,AACD,mJACI,UAAW,AACX,yBAA0B,AAC1B,4DAAwE,AACxE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,wBAA0B,AAC1B,mBAAoB,AACpB,8CAAmD,AAC3C,sCAA2C,AACnD,eAAiB,CACpB,AACD,mCACE,WAAY,AACZ,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,gBAAiB,AACjB,8CAAmD,AAC3C,qCAA2C,CACpD,AACD,kFACI,yBAA0B,AAC1B,gBAAkB,CACrB,AACD,yCACI,cAAe,AACf,6DAAuE,AACvE,gBAAkB,AAClB,oCAA0C,CAC7C,AACD,uDACI,gCAAsC,CACzC,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,0BAA2B,AACvB,uBAAwB,AACpB,oBAAqB,AAC7B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,4CACI,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,2DACM,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,aAAe,CACpB,AACD,kDACI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,iEACM,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,cAAgB,CACrB,AACD,iCACE,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,gBAAmB,AACnB,iBAAmB,CACpB,AACD,4BACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,cAAgB,CACjB,AACD,yCACE,mBAAoB,AACpB,YAAa,AACb,WAAY,AACZ,YAAa,AACb,WAAe,AACf,gBAAkB,AAClB,kBAAmB,AACnB,8DAAqE,AACrE,4CAAiD,AACzC,oCAAyC,AACjD,cAAgB,CACjB,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,UAAW,AACX,SAAU,AACV,eAAkB,CACnB,AACD,8BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAId,OAAS,CACV,AACD,4DALE,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAuB7B,AApBD,8BACE,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AAIrB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mDAAsD,AACtD,WAAa,AACb,gBAAkB,AAClB,eAAgB,AAChB,4CAAiD,AACzC,oCAAyC,AACjD,qBAA0B,CAC3B,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,8BACE,yBAA0B,AAC1B,WAAa,AACb,gBAAiB,AACjB,mBAAoB,AACpB,gBAAkB,AAClB,eAAgB,AAChB,4CAAiD,AACzC,mCAAyC,CAClD,AACD,mCACE,qBAAsB,AACtB,gBAAiB,AACjB,mBAAoB,AACpB,mDAAsD,AACtD,WAAa,AACb,gBAAkB,AAClB,eAAgB,AAChB,4CAAiD,AACzC,oCAAyC,AACjD,qBAA0B,CAC3B,AACD,+CACE,mDAAsD,AACtD,eAAgB,AAChB,gBAAkB,CACnB,AACD,uCACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,kBAAmB,AACnB,wBAA0B,AAC1B,uEAAkF,AAClF,kBAAmB,AACnB,6CAAkD,AAC1C,oCAA0C,CACnD,AACD,qCACE,WAAY,AACZ,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,SAAU,AACV,mBAAoB,AACpB,mBAAoB,AACpB,gBAAiB,AACjB,8CAAmD,AAC3C,qCAA2C,CACpD,AACD,sFACI,yBAA0B,AAC1B,gBAAiB,AACjB,cAAe,AACf,6DAAuE,AACvE,gBAAiB,AACjB,oCAA0C,CAC7C,AACD,+BACE,WAAY,AACZ,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,SAAU,AACV,mBAAoB,AACpB,mBAAoB,AACpB,gBAAiB,AACjB,8CAAmD,AAC3C,sCAA2C,AACnD,+CAAiD,AACjD,uCAAyC,AACzC,+BAAiC,AACjC,0DAA+D,CAChE,AACD,qCACI,8CAAmD,AAC3C,qCAA2C,CACtD,AACD,0EACI,yBAA0B,AAC1B,gBAAiB,AACjB,cAAe,AACf,sBAAuB,AACvB,6CAA+C,AAC/C,oCAAuC,CAC1C,AACD,qCACI,0EAAqF,AACrF,eAAiB,CACpB,AACD,2CACI,oCAA0C,CAC7C,AACD,+BACE,WAAY,AACZ,YAAa,AACb,yBAA0B,AAC1B,SAAU,AACV,UAAW,AACX,kBAAoB,CACrB,AACD,qCACI,YAAa,AACb,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,qBAAsB,AACtB,yBAA0B,AAC1B,qBAAsB,AACd,aAAc,AACtB,cAAgB,CACnB,AACD,iCACE,aAAc,AACd,yBAA0B,AAC1B,mBAAoB,AACpB,8CAAmD,AAC3C,sCAA2C,AACnD,gBAAoB,AACpB,kBAAmB,AACnB,eAAiB,CAClB,AACD,uCACI,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,oFAA2F,AAC3F,mBAAqB,CACxB,AACD,iCAIE,mBAAoB,AAChB,eAAgB,AAIpB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,UAAW,AACX,gBAAiB,AACjB,mBAAoB,AACpB,SAAU,AACV,aAAc,AACd,4DAAwE,AACxE,mCAA2C,AAC3C,mBAAoB,AACpB,8CAAmD,AAC3C,qCAA2C,CAEpD,AACD,+EAvBE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAGd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAc5B,iBAAmB,CAkBpB,AAhBD,8CAOI,SAAU,AACV,kBAAmB,AACnB,mBAAoB,AACpB,2DAAuE,AACvE,iCAAsC,AACtC,8CAAmD,AAC3C,sCAA2C,AAEnD,SAAW,CACd,AACD,4DACM,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,6CAAkD,AAC1C,qCAA0C,AAClD,sBAA0B,AAC1B,iBAAmB,CACxB,AACD,kEACQ,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,WAAa,AACb,UAAY,CACnB,AACD,gDACM,SAAU,AACV,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,mBAAsB,CAC3B,AACD,yCACE,kBAAmB,AACnB,gBAAkB,CACnB,AACD,kCACE,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,qCAA4C,AAC5C,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,aAAc,AACd,kCAAmC,AAC3B,yBAA2B,CACpC","file":"report-summary.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header[data-v-987587e4] {\n  color: #f09c2b;\n  font-size: 16px;\n  font-weight: bold;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.date-header[data-v-987587e4] {\n  color: #545a54;\n  font-size: 16px;\n  font-weight: bold;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.methodology[data-v-987587e4] {\n  width: 90%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 20px auto;\n  border: 1px solid #e7e7e7;\n  background: linear-gradient(135deg, #e7e7e7, rgba(231, 231, 231, 0.8));\n  border-radius: 20px;\n  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.methodology .meth[data-v-987587e4] {\n    color: #5ed52b !important;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 15px;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.methodology .parraf[data-v-987587e4] {\n    color: #858585 !important;\n    font-size: 14px;\n    padding: 15px;\n    line-height: 1.5;\n}\n.columns-competencies[data-v-987587e4] {\n  width: 90%;\n  display: grid;\n  gap: 15px;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 20px auto 50px;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n.columns-competencies .title-box[data-v-987587e4] {\n    color: #5ed52b;\n    margin: 0 !important;\n    padding: 0 !important;\n    font-weight: 600;\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.columns-competencies .line[data-v-987587e4] {\n    width: 40%;\n    margin-bottom: 10px;\n    border: 1px solid #5ed52b;\n    background: -webkit-gradient(linear, left top, right top, from(transparent), color-stop(#5ed52b), to(transparent));\n    background: linear-gradient(90deg, transparent, #5ed52b, transparent);\n    height: 2px;\n}\n.columns-competencies .box[data-v-987587e4] {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(145deg, #ffffff, rgba(255, 255, 255, 0.95));\n    border: 1px solid #e7e7e7;\n    border-radius: 12px;\n    padding: 15px 25px 20px;\n    color: #858585 !important;\n    -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n}\n.columns-competencies .box .table-evaluation[data-v-987587e4] {\n      width: 100%;\n      border: 1px solid #e7e7e7;\n      border-collapse: collapse;\n      text-align: center;\n      margin-top: 10px;\n}\n.columns-competencies .box .table-evaluation th[data-v-987587e4], .columns-competencies .box .table-evaluation td[data-v-987587e4] {\n        border: 1px solid #e7e7e7;\n        padding: 8px 5px;\n}\n.columns-competencies .box .table-evaluation th[data-v-987587e4] {\n        color: #f09c2b;\n        background-color: #e7e7e7;\n        font-weight: bold;\n}\n.columns-competencies .box ol[data-v-987587e4], .columns-competencies .box ul[data-v-987587e4] {\n      padding-left: 20px;\n      margin: 10px 0 0 0;\n}\n.columns-competencies .box ol li[data-v-987587e4], .columns-competencies .box ul li[data-v-987587e4] {\n        margin-bottom: 8px;\n        line-height: 1.4;\n}\n.global-results-columns[data-v-987587e4] {\n  grid-template-columns: 1fr 1fr;\n  justify-items: center;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.global-results-columns div[data-v-987587e4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%;\n}\n.global-results-columns .box[data-v-987587e4] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.results-tables-container[data-v-987587e4] {\n  width: 90%;\n  display: grid;\n  gap: 15px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: auto;\n  grid-template-columns: 1fr;\n  max-width: 800px;\n}\n.results-tables-container .title-box[data-v-987587e4] {\n    color: #5ed52b;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n.results-tables-container .line[data-v-987587e4] {\n    width: 40%;\n    margin-bottom: 10px;\n    border: 1px solid #5ed52b;\n}\n.results-tables-container .box[data-v-987587e4] {\n    width: 100%;\n    height: auto;\n    min-height: 200px;\n    background-color: #ffffff;\n    border: 1px solid #e7e7e7;\n    border-radius: 10px;\n    padding: 20px 25px;\n    color: #858585 !important;\n}\n.results-tables-container.has-kpis[data-v-987587e4] {\n  grid-template-columns: 1fr;\n  max-width: 100%;\n  justify-items: center;\n}\n.results-tables-container.has-kpis > div[data-v-987587e4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%;\n    max-width: 800px;\n}\n.results-tables-container.has-kpis .box[data-v-987587e4] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.global-results[data-v-987587e4], .diagram-dispersion[data-v-987587e4], .detailed-table-section[data-v-987587e4] {\n  width: 90%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 20px auto;\n}\n.global-results .results[data-v-987587e4], .diagram-dispersion .results[data-v-987587e4], .detailed-table-section .results[data-v-987587e4] {\n    color: #f09c2b;\n    font-size: 18px;\n    font-weight: bold;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 15px;\n}\n.global-results .connt-info[data-v-987587e4], .diagram-dispersion .connt-info[data-v-987587e4], .detailed-table-section .connt-info[data-v-987587e4] {\n    width: 80%;\n    border: 1px solid #e7e7e7;\n    background: linear-gradient(145deg, #ffffff, rgba(255, 255, 255, 0.95));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    text-align: center;\n    margin: 20px auto;\n    padding: 20px 25px;\n    color: #858585 !important;\n    border-radius: 20px;\n    -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    line-height: 1.5;\n}\n.table-evaluation[data-v-987587e4] {\n  width: 100%;\n  border: 1px solid #e7e7e7;\n  border-collapse: collapse;\n  text-align: center;\n  min-height: 180px;\n  border-radius: 10px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.table-evaluation tr th[data-v-987587e4], .table-evaluation tr td[data-v-987587e4] {\n    border: 1px solid #e7e7e7;\n    padding: 10px 8px;\n}\n.table-evaluation tr th[data-v-987587e4] {\n    color: #f09c2b;\n    background: linear-gradient(135deg, #e7e7e7, rgba(231, 231, 231, 0.8));\n    font-weight: bold;\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.table-evaluation tr tr[data-v-987587e4]:nth-child(even) {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n.tables-container[data-v-987587e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 20px;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.tables-container.has-kpis[data-v-987587e4] {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.tables-container.has-kpis .table-section[data-v-987587e4] {\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      max-width: 48%;\n}\n.tables-container[data-v-987587e4]:not(.has-kpis) {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.tables-container:not(.has-kpis) .table-section[data-v-987587e4] {\n      -webkit-box-flex: 1;\n          -ms-flex: 1;\n              flex: 1;\n      max-width: 100%;\n}\n.table-subtitle[data-v-987587e4] {\n  color: #5ed52b;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 10px 0;\n  text-align: center;\n}\n.character[data-v-987587e4] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  padding: 10px 0;\n}\n.character-abbreviation[data-v-987587e4] {\n  border-radius: 50px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  color: #ffffff;\n  font-weight: bold;\n  text-align: center;\n  background: linear-gradient(135deg, #5ed52b, rgba(94, 213, 43, 0.8));\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.point-value[data-v-987587e4] {\n  color: #5ed52b;\n  font-size: 10px;\n  padding: 0;\n  margin: 0;\n  font-weight: bold;\n}\n.scale-entry[data-v-987587e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n}\n.scale-badge[data-v-987587e4] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #f09c2b, #FFB74C);\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border: 2px solid #ffffff;\n}\n.scale-label[data-v-987587e4] {\n  color: #858585;\n  font-size: 12px;\n  font-weight: 500;\n}\n.score-display[data-v-987587e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 5px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.score-badge[data-v-987587e4] {\n  background-color: #5ed52b;\n  color: white;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-weight: bold;\n  font-size: 10px;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.percentage-badge[data-v-987587e4] {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #5ed52b, #55ac4b);\n  color: white;\n  font-weight: bold;\n  font-size: 10px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border: 1px solid #ffffff;\n}\n.percentage-badge.total-badge[data-v-987587e4] {\n  background: linear-gradient(135deg, #f09c2b, #FFB74C);\n  font-size: 12px;\n  padding: 6px 12px;\n}\n.character-dispersion[data-v-987587e4] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n  padding: 12px 35px;\n  color: #858585 !important;\n  background: linear-gradient(135deg, #e7e7e7, rgba(231, 231, 231, 0.9)) !important;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n.t-dispersion-title[data-v-987587e4] {\n  width: 100%;\n  border: 1px solid #e7e7e7;\n  border-collapse: collapse;\n  text-align: center;\n  margin: 0;\n  table-layout: fixed;\n  border-radius: 10px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.t-dispersion-title tr th[data-v-987587e4], .t-dispersion-title tr td[data-v-987587e4] {\n    border: 1px solid #e7e7e7;\n    padding: 8px 5px;\n    color: #858585;\n    background: linear-gradient(135deg, #e7e7e7, rgba(231, 231, 231, 0.8));\n    font-weight: 600;\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.t-dispersion[data-v-987587e4] {\n  width: 100%;\n  border: 1px solid #e7e7e7;\n  border-collapse: collapse;\n  text-align: center;\n  margin: 0;\n  table-layout: fixed;\n  border-radius: 10px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  -webkit-transition: -webkit-box-shadow 0.3s ease;\n  transition: -webkit-box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease, -webkit-box-shadow 0.3s ease;\n}\n.t-dispersion[data-v-987587e4]:hover {\n    -webkit-box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n.t-dispersion tr th[data-v-987587e4], .t-dispersion tr td[data-v-987587e4] {\n    border: 1px solid #e7e7e7;\n    padding: 8px 5px;\n    color: #858585;\n    vertical-align: middle;\n    -webkit-transition: background-color 0.2s ease;\n    transition: background-color 0.2s ease;\n}\n.t-dispersion tr th[data-v-987587e4] {\n    background: linear-gradient(135deg, rgba(94, 213, 43, 0.1), rgba(94, 213, 43, 0.05));\n    font-weight: 600;\n}\n.t-dispersion tr:hover td[data-v-987587e4] {\n    background-color: rgba(94, 213, 43, 0.05);\n}\n.nested-table[data-v-987587e4] {\n  width: 100%;\n  border: none;\n  border-collapse: collapse;\n  margin: 0;\n  padding: 0;\n  table-layout: fixed;\n}\n.nested-table tr td[data-v-987587e4] {\n    border: none;\n    padding: 4px 0;\n    color: #858585;\n    font-size: 12px;\n    line-height: 1.4;\n    text-align: start;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    -webkit-hyphens: auto;\n            hyphens: auto;\n    max-width: 100%;\n}\n.grafic-content[data-v-987587e4] {\n  padding: 30px;\n  border: 1px solid #e7e7e7;\n  border-radius: 12px;\n  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  background: #ffffff;\n  position: relative;\n  overflow: hidden;\n}\n.grafic-content[data-v-987587e4]::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: radial-gradient(circle at top right, rgba(94, 213, 43, 0.03), transparent 70%);\n    pointer-events: none;\n}\n.leyend-graphic[data-v-987587e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 85%;\n  max-width: 800px;\n  margin: 25px auto 0;\n  gap: 20px;\n  padding: 25px;\n  background: linear-gradient(145deg, #ffffff, rgba(255, 255, 255, 0.98));\n  border: 1px solid rgba(231, 231, 231, 0.8);\n  border-radius: 16px;\n  -webkit-box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  position: relative;\n}\n.leyend-graphic .legend-item[data-v-987587e4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 12px;\n    padding: 12px 20px;\n    border-radius: 50px;\n    background: linear-gradient(145deg, rgba(255, 255, 255, 0.9), #ffffff);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\n    position: relative;\n    z-index: 1;\n}\n.leyend-graphic .legend-item .legend-color[data-v-987587e4] {\n      width: 18px;\n      height: 18px;\n      border-radius: 50%;\n      -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);\n              box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);\n      border: 2px solid #ffffff;\n      position: relative;\n}\n.leyend-graphic .legend-item .legend-color[data-v-987587e4]::after {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        border-radius: 50%;\n        background: inherit;\n        opacity: 0.2;\n        z-index: -1;\n}\n.leyend-graphic .legend-item p[data-v-987587e4] {\n      margin: 0;\n      font-size: 13px;\n      font-weight: 500;\n      color: #858585;\n      letter-spacing: 0.2px;\n}\n.report-summary-wrapper[data-v-987587e4] {\n  position: relative;\n  min-height: 100vh;\n}\n.loading-overlay[data-v-987587e4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.85);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  z-index: 9999;\n  -webkit-backdrop-filter: blur(2px);\n          backdrop-filter: blur(2px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graphic_vue__ = __webpack_require__(2121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20917d8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_graphic_vue__ = __webpack_require__(2978);
function injectStyle (ssrContext) {
  __webpack_require__(2976)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20917d8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graphic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20917d8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_graphic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2976:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("2f00a4a8", content, true, {});

/***/ }),

/***/ 2977:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}@media print{.graphic[data-v-20917d8e]{height:460px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/charts/graphic.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,aACA,0BACI,YAAc,CACjB,CACA","file":"graphic.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@media print {\n.graphic[data-v-20917d8e] {\n    height: 460px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"graphic",attrs:{"id":"canvas","width":"950","height":"550"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-summary-wrapper"},[(_vm.isLoading || _vm.isDownloading)?_c('div',{staticClass:"loading-overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1):_vm._e(),_vm._v(" "),_c('title-header',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":"","aling-center":""}},[_c('p',{staticClass:"title-header"},[_vm._v("Evaluado: "),_c('span',{staticClass:"date-header"},[_vm._v(_vm._s(_vm.selectedEmployee.fullName)+" ( "+_vm._s(_vm.selectedEmployee.job ? _vm.selectedEmployee.job.name : '')+" )")])]),_vm._v(" "),_c('p',{staticClass:"title-header"},[_vm._v("Fecha de Evaluación: "),_c('span',{staticClass:"date-header"},[_vm._v(_vm._s(_vm.startDate)+" - "+_vm._s(_vm.endDate))])])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('div',{staticClass:"wrapper-btns tw-mr-2"},[_c('download-btn',{attrs:{"alt":"Descargar reporte en PDF","height":27,"disabled":!_vm.canExportReport,"url-image":"/static/img/icons/pdf.svg"},on:{"download-item":function($event){_vm.downloadReport('pdf')}}})],1),_vm._v(" "),_c('div',{staticClass:"wrapper-btns tw-mr-10"},[_c('app-tooltip-button',{attrs:{"text":"Enviar reporte a E-mail","img":"/static/img/mail.svg","disabled":!_vm.canExportReport},on:{"click-icon":_vm.sendEmail}})],1),_vm._v(" "),_c('div',{staticClass:"wrapper-btns"},[_c('v-btn',{attrs:{"color":"primary btn-action"},on:{"click":_vm.goToBack}},[_c('img',{staticClass:"mr-4",attrs:{"src":"/static/img/icons/btn-right-arrow.webp","alt":"Atrás"}}),_vm._v("\n\t\t\t\t\t\t\tAtrás\n\t\t\t\t\t\t")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"methodology"},[_c('table',[_c('tr',[_c('td',{staticClass:"meth"},[_vm._v("METODOLOGÍA:")]),_vm._v(" "),_c('td',{staticClass:"parraf"},[_vm._v(_vm._s(_vm.process.methodology))])])])]),_vm._v(" "),(!_vm.isLoading && _vm.competences.length > 0)?_c('section',{staticClass:"columns-competencies"},[_c('div',[_c('p',{staticClass:"title-box"},[_vm._v("Competencias Exploradas:")]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"box"},[[_c('ol',_vm._l((_vm.competences),function(competence,index){return _c('li',{key:index},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(competence.competenceName)+"\n\t\t\t\t\t\t\t")])}),0)]],2)]),_vm._v(" "),_c('div',[_c('p',{staticClass:"title-box"},[_vm._v("Grupos de Evaluación:")]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('ul',_vm._l((_vm.roles),function(role,index){return _c('li',{key:index},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(role.name)+" ("+_vm._s(role.abbreviation)+")\n\t\t\t\t\t\t")])}),0)])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"title-box"},[_vm._v("Alternativas de Evaluación:")]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('table',{staticClass:"table-evaluation"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.scales),function(scale,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"font-size":"smaller"}},[_vm._v(_vm._s(scale.name))]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"smaller"}},[_vm._v(_vm._s(scale.value))])])})],2)])])]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.scales.length > 0)?_c('section',{staticClass:"global-results"},[_c('p',{staticClass:"results"},[_vm._v("RESULTADOS GLOBALES")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"results-tables-container",class:{'has-kpis' : _vm.kpis}},[_c('div',[_c('p',{staticClass:"title-box"},[_vm._v("Puntuaciones Totales"+_vm._s(_vm.kpis ? ' y Resúmen KPI' : '')+":")]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"tables-container",class:{ 'has-kpis': _vm.kpis }},[_c('div',{staticClass:"table-section"},[_c('p',{staticClass:"table-subtitle"},[_vm._v("Escalas de Evaluación")]),_vm._v(" "),_c('table',{staticClass:"table-evaluation"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.scales),function(scale,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"font-size":"smaller","text-align":"start"}},[_c('div',{staticClass:"scale-entry"},[_c('div',{staticClass:"scale-badge"},[_vm._v(_vm._s(scale.value))]),_vm._v(" "),_c('div',{staticClass:"scale-label"},[_vm._v(_vm._s(scale.name))])])]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"smaller"}},[_c('div',{staticClass:"score-display"},[(scale.point)?_c('button',{staticClass:"character-abbreviation"},[_vm._v("T")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"point-value"},[_vm._v(_vm._s(scale.pointValue))])])])])})],2)]),_vm._v(" "),(_vm.kpis)?_c('div',{staticClass:"table-section"},[_c('p',{staticClass:"table-subtitle"},[_vm._v("Resumen KPI")]),_vm._v(" "),_c('table',{staticClass:"table-evaluation kpi-table"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.kpis),function(kpi,index){return _c('tr',{key:("kpi-" + index)},[_c('td',{staticStyle:{"font-size":"smaller","text-align":"start"}},[_vm._v(_vm._s(kpi.typeCompetenceName))]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"smaller"}},[_c('p',{staticClass:"point-value"},[_vm._v(_vm._s(_vm._f("round")(kpi.totalWeighing))+"%")])])])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"smaller","text-align":"start","font-weight":"bold"}},[_vm._v("Total Ponderado")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"smaller"}},[_c('p',{staticClass:"point-value"},[_vm._v(_vm._s(_vm._f("round")(_vm.totalKpi))+"%")])])])],2)]):_vm._e()]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div')]),_vm._v(" "),(!_vm.isLoading && _vm.dataGraphic.values && _vm.dataGraphic.values.length > 0)?_c('div',{staticClass:"grafic-content tw-mt-6"},[_c('graphic',{ref:"graphicComponent",attrs:{"data":_vm.dataGraphic},on:{"drawn":_vm.captureCanvas,"drawn-error":_vm.onGraphicDrawError}})],1):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.typeCompetencies.length > 0)?_c('div',{staticClass:"leyend-graphic"},_vm._l((_vm.typeCompetencies),function(typeCompetence,index){return _c('div',{key:index,staticClass:"legend-item"},[_c('div',{staticClass:"legend-color",style:(("background-color: " + (typeCompetence.color) + ";"))}),_vm._v(" "),_c('p',[_vm._v(_vm._s(typeCompetence.nameCompetencie))])])}),0):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.flattenedTableData.length > 0)?_c('section',{staticClass:"diagram-dispersion"},[_c('p',{staticClass:"results"},[_vm._v("DIAGRAMA DE DISPERSIÓN")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.flattenedTableData.length > 0)?_c('section',{staticClass:"table-dispersion tw-my-10"},[_c('table',{staticClass:"t-dispersion-title"},[_c('tr',[_c('th',{staticStyle:{"width":"20%"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"45%"}}),_vm._v(" "),_vm._l((_vm.scales),function(scale,index){return _c('th',{key:index,style:(("width: " + (35 / _vm.scales.length) + "%;"))},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(scale.name)+"\n\t\t\t\t\t")])})],2)]),_vm._v(" "),_c('table',{staticClass:"t-dispersion"},_vm._l((_vm.flattenedTableData),function(row,index){return _c('tr',{key:index},[(row.isFirstQuestion)?_c('th',{staticStyle:{"width":"20%"},attrs:{"rowspan":row.rowspan}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(row.competenceName)+"\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"width":"45%","text-align":"start"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(row.questionName)+"\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((row.scaleQuestions),function(scaleQuestion,indexSQ){return _c('td',{key:indexSQ,style:(("width: " + (35 / _vm.scales.length) + "%;"))},[(scaleQuestion.point)?_c('button',{staticClass:"character-abbreviation"},[_vm._v("T")]):_vm._e()])})],2)}),0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.detailedTableFiltered.length > 0)?[_vm._m(7),_vm._v(" "),_c('section',{staticClass:"table-dispersion tw-my-10"},[_vm._m(8),_vm._v(" "),_c('table',{staticClass:"t-dispersion"},_vm._l((_vm.detailedTableFiltered),function(row,index){return _c('tr',{key:index},[(row.isFirstQuestion)?_c('th',{staticStyle:{"width":"10%"},attrs:{"rowspan":row.rowspan}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(row.competenceName)+"\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"width":"18%","text-align":"start"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(row.questionName)+"\n\t\t\t\t\t\t")]),_vm._v(" "),(row.isFirstQuestion)?_c('td',{staticStyle:{"width":"24%","text-align":"start"},attrs:{"rowspan":row.rowspan}},[_c('table',{staticClass:"nested-table"},_vm._l(((row.indicator && row.indicator.activity) || []),function(indicator,indI){return _c('tr',{key:("activity-" + indI)},[_c('td',[_vm._v(_vm._s(indicator.text))])])}),0)]):_vm._e(),_vm._v(" "),(row.isFirstQuestion)?_c('td',{staticStyle:{"width":"24%","text-align":"start"},attrs:{"rowspan":row.rowspan}},[_c('table',{staticClass:"nested-table"},_vm._l(((row.indicator && row.indicator.reading) || []),function(indicator,indI){return _c('tr',{key:("reading-" + indI)},[_c('td',[_vm._v(_vm._s(indicator.text))])])}),0)]):_vm._e(),_vm._v(" "),(row.isFirstQuestion)?_c('td',{staticStyle:{"width":"24%","text-align":"start"},attrs:{"rowspan":row.rowspan}},[_c('table',{staticClass:"nested-table"},_vm._l(((row.indicator && row.indicator.filmGenre) || []),function(indicator,indI){return _c('tr',{key:("film-" + indI)},[_c('td',[_vm._v(_vm._s(indicator.text))])])}),0)]):_vm._e()])}),0)])]:_vm._e(),_vm._v(" "),_c('btn-float',{attrs:{"buttonText":"Subir"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Descripción:")]),_vm._v(" "),_c('th',[_vm._v("Valor:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connt-info"},[_c('p',[_vm._v("A continuación se muestra los resultados de las competencias genéricas exploradas, comparando el promedio de puntuación de todos los grupos de referencia.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Descripción:")]),_vm._v(" "),_c('th',[_vm._v("Puntuación:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Descripción:")]),_vm._v(" "),_c('th',[_vm._v("Puntuación:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character"},[_c('button',{staticClass:"character-abbreviation"},[_vm._v("T")]),_vm._v(" "),_c('p',[_vm._v("Todos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connt-info"},[_c('p',[_vm._v("Esta página presenta la posición relativa a la puntuación promedio de las competencias para cada uno de los grupos de observadores. Se muestra cada competencia con su respectivo grupo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character-dispersion"},[_c('button',{staticClass:"character-abbreviation"},[_vm._v("T")]),_vm._v(" "),_c('h4',[_vm._v("Todos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"detailed-table-section tw-my-10"},[_c('p',{staticClass:"results"},[_vm._v("PLAN DE DESARROLLO")]),_vm._v(" "),_c('div',{staticClass:"connt-info"},[_c('p',[_vm._v("Esta sección detalla el sustento de indicadores de desempeño y\n\t\t\t\t\t\tlas propuestas de mejora continua; un análisis basado en la ejecución\n\t\t\t\t\t\tde actividades, la profundización académica mediante la lectura y\n\t\t\t\t\t\tla perspectiva analítica del género cinematográfico como respaldo a\n\t\t\t\t\t\tlas competencias.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"t-dispersion-title"},[_c('tr',[_c('th',{staticStyle:{"width":"10%"}},[_vm._v("Competencia")]),_vm._v(" "),_c('th',{staticStyle:{"width":"18%"}},[_vm._v("Pregunta")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24%"}},[_vm._v("Actividades")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24%"}},[_vm._v("Lecturas")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24%"}},[_vm._v("Género Cinematográfico")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/68.a110293ed3f44fd612ff.js